// @ts-nocheck
export const fmtDate = (d) =>
  new Date(d).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
export const fmtDateShort = (d) =>
  new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric" });
